import {nsObjectUpload} from "./fn";
import {AbstractUpload, template as tpl} from "./AbstractUpload";
import {IRouteDefinitionParams} from "../../../index";
import Step = nsObjectUpload.Step;

export let template = tpl;

export class viewModel extends AbstractUpload {
    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.step(Step.Init);
    }
}
